import $okgportal_api from "@/shared/client/okgportal.client";
import { UserInterface } from "@/shared/model/api.types";
import { BaseOkgportalResponce } from "@/shared/model/api.types";

class UserApi{
  async getAll(){
    try {
      const response = await $okgportal_api.get<BaseOkgportalResponce<UserInterface[]>>('/user/all');
      return response.data
    } catch (error) {
      throw error
    }
  }
}

const userApi = new UserApi();
export default userApi;